<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker locale="vi" id="datepicker" v-model="dateRange" :model-config="dateRangeConfig" :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" is-range class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="inputValue.start + ' - ' + inputValue.end"
                v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                readonly
              />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
        <BaseSelect
          :options="districtCodeInput.options"
          :data="districtCodeInput.data"
          ref="districtCodeInput"
        ></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2" v-if="!$hasAuthor('ROLE_WARD')">
        <BaseSelect
          :options="wardCodeInput.options"
          :data="wardCodeInput.data"
          ref="wardCodeInput"
        ></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseInput
          :options="titleInput.options"
          :data="titleInput.data"
          :listener="titleInput.listener"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right; margin-left: 5px"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)"
            >
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-if="item.createDate == null"></td>
          </template>
          <template #level="{ item }">
            <td>
              <span class="badge badge-success" v-if="item.level == 0"
              >Bình thường</span
              >
              <span class="badge badge-warning" v-if="item.level == 1"
              >Ưu tiên</span
              >
              <span class="badge badge-danger" v-if="item.level == 2"
              >Khẩn cấp</span
              >
            </td>
          </template>
          <template #url="{ item }">
            <td>
              <span class="view-file" v-if="item.url" @click="viewFile(item.url)">Ấn vào để xem tệp</span>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import {LOCATION_CODE_NAME, AudioHistoryType} from "../../../constant";
import BaseTable from "../../base/BaseDataTable";
import BaseInput from "../../base/BaseInput";
import BaseSelect from "../../base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import {DatePicker} from "v-calendar";

export default {
  name: "AudioFilePlayingList",
  components: {
    BaseFormLoading,
    BaseTable,
    BaseInput,
    BaseSelect,
    DatePicker
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    return {
      loading: {value: false},
      dateRange: {
        start: new Date().setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999)
      },
      dateRangeConfig: {
        start: {
          timeAdjust: '00:00:00',
        },
        end: {
          timeAdjust: '23:59:59',
        },
      },
      titleInput: {
        options: {
          placeholder: "Tiêu đề bản tin",
          label: "Tiêu đề bản tin",
        },
        data: {
          name: "fileName",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      historyType: {
        data: {
          name: "historyType",
          model: AudioHistoryType.DANG_PHAT,
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          keyField: "key",
          valueField: "value",
          lazyLoad:
            this.$hasAuthor("ROLE_ADMIN") || this.$hasAuthor("ROLE_PROVINCE")
              ? false
              : true,
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: "/common/findByParentCodeAndCode",
            dataSubmit: function () {
              return {};
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            },
          },
          // updateTrigger: function () {
          //   return that.$refs.mainTable;
          // },
        },
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          keyField: "key",
          valueField: "value",
          lazyLoad: this.$hasAuthor("ROLE_DISTRICT") ? false : true,
          disabled: this.$hasAuthor("ROLE_DISTRICT") ? false : true,
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: "/common/findByParentCodeAndCode",
            dataSubmit: function () {
              return {
                parentCode:
                  that.districtCodeInput.data.model
              };
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            },
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      locationCode: {
        data: {
          name: "locationCode",
          model: "",
        },
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT"},
            {key: "fileName", label: "Tiêu đề", _style: "max-width:20%; width:20%"},
            {key: "createDate", label: "Thời gian phát"},
            {key: "level", label: "Cấp độ"},
            {key: "deviceCode", label: "Mã thiết bị phát"},
            { key: "location", label: "Địa bàn" },
            {key: "url", label: "Tệp"},
          ],
          slots: ["index", "level", "createDate", "status", "url"],
          lazyLoad: this.$hasAuthor('ROLE_WARD') ? true : false,
        },
        dataSource: {
          url: "/audio-file-history/getPages",
          dataSubmit: function () {
            // return that.$helper.setupDataSubmit(that.$data);
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate= that.$helper.formatDate(that.dateRange.start);
            params.toDate= that.$helper.formatDate(that.dateRange.end);
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    async viewFile(url) {
      // let that = this;
      // this.loading.value = true;
      // const data = await this.$helper.blobFileByUrl(url);
      // setTimeout(() => {
      //   that.loading.value = false;
      //   window.open(data);
      // }, 500);
      window.open(this.$helper.viewFileByUrl(url))
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    "districtCodeInput.data.model": function (value) {
      if (value) {
        this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        this.wardCodeInput.options.disabled = false;
      } else {
        this.wardCodeInput.data.items = [];
        this.wardCodeInput.options.disabled = true;
      }
      this.wardCodeInput.data.model = null;
    },
    "wardCodeInput.data.model": function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
    },
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: new Date().setHours(0,0,0,0),
          end: new Date().setHours(23,59,59,999)
        }
      }
    }
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
